import React, { FC } from 'react'
import styles from './MobilityMenu.module.scss'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'components/Tooltip'
import { Icon } from 'components/Icon'
import { Dialog } from 'components/Dialog'
import { Heading } from 'components/Heading'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { Button } from 'components/Button'
// import { Calendar } from 'components/Calendar'
import { useDispatch } from 'react-redux'
import { createTempMobilityProject, createTempHistoricalProject } from 'actions/project'
import { useFetchOrganization } from 'services/organization'

declare global {
  interface Date {
    addDays(days: number, useThis?: boolean): Date
    subDays(days: number, useThis?: boolean): Date
  }
}

// eslint-disable-next-line
Date.prototype.addDays = function (days: number): Date {
  const date = new Date(this.valueOf())
  date.setDate(date.getDate() + days)

  return date
}

// eslint-disable-next-line
Date.prototype.subDays = function (days: number): Date {
  const date = new Date(this.valueOf())
  date.setDate(date.getDate() - days)

  return date
}

type MobilityMenuProps = {
  projectId: string
}

export const MobilityMenu: FC<MobilityMenuProps> = ({ projectId }) => {
  const { t } = useTranslation()
  const [menuActive, setMenuActive] = React.useState<boolean>(false)
  const [mobilityDialog, setMobilityDialog] = React.useState<boolean>(false)
  const [mobilityType, setMobilityType] = React.useState<String | undefined>(undefined)
  // const today = new Date()
  // const [startDate, setStartDate] = React.useState<Date>(today.subDays(8))
  // const [endDate, setEndDate] = React.useState<any>(startDate.addDays(1))
  const dispatch = useDispatch()
  const { organization } = useFetchOrganization()

  //solucion temporal ya que el organization mobility movement viene como undefined
  var orgMM = organization?.mobilityMovement
  var orgMH = organization?.mobilityHistorical
  if (orgMM === undefined || orgMM === null) {
    orgMM = 0
  }
  if (orgMH === undefined || orgMH === null) {
    orgMH = 0
  }

  const buttonStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '30px',
    height: '30px',
    border: 'none',
    background: 'none',
    backgroundColor: '#fff',
    padding: '0',
    cursor: 'pointer',
  }

  const buttonContainerStyles = {
    cursor: 'pointer',
    backgroundColor: '#fff',
  }

  /*const excludedDates = [
    startDate.addDays(1),
    startDate.addDays(2),
    startDate.addDays(3),
    startDate.addDays(4),
    startDate.addDays(5),
    today,
    today.subDays(1),
    today.subDays(2),
    today.subDays(3),
    today.subDays(4),
    today.subDays(5),
  ]*/

  const handleMobilityDialog = () => {
    setMobilityDialog(false)
  }

  const handleMobilityClick = () => {
    if (projectId) {
      setMobilityDialog(true)
      setMobilityType('mobility')
    }
  }

  const handleHistoricClick = () => {
    if (projectId) {
      setMobilityDialog(true)
      setMobilityType('historic')
    }
  }

  /*const onDateChange = (dates: any) => {
    const [start, end] = dates

    setStartDate(start)
    setEndDate(end)
  }*/

  const refreshSite = () => {
    setTimeout(() => window.location.reload(), 4500)
  }

  const handleCreateMobilityProject = () => {
    if (mobilityType === 'mobility' && orgMM! > 0) {
      const staticInitialDate = new Date(2023, 7, 1)
      const staticEndDate = new Date(2023, 7, 31)

      const arrIniDate = staticInitialDate.toISOString() // When Calendar is enabled again, I need to change this for staticInitialDate.toISOString()
      const splitIniDate = arrIniDate.replace(/-/g, '')
      const subsIniDate = splitIniDate.substring(0, 8)
      const arrFinDate = staticEndDate.toISOString() // When Calendar is enabled again, I need to change this for staticInitialDate.toISOString()
      const splitFinDate = arrFinDate.replace(/-/g, '')
      const subsFinDate = splitFinDate.substring(0, 8)
      dispatch(createTempMobilityProject(projectId, subsIniDate, subsFinDate))

      setMobilityType(undefined)
      setMobilityDialog(false)
      refreshSite()
    } else if (mobilityType === 'historic' && orgMH! > 0) {
      dispatch(createTempHistoricalProject(projectId))

      setMobilityType(undefined)
      setMobilityDialog(false)
      refreshSite()
    } else {
      console.error('Excepción no controlada')
    }
  }

  return (
    <div className={styles.mobilityMenu}>
      <Dialog
        className={styles.calendarWrapper}
        isOpen={mobilityDialog}
        onClose={handleMobilityDialog}
        aria-label="no se que va aqui"
      >
        {/* Mobility project dialog content */}

        {mobilityType === 'mobility' && (
          <React.Fragment>
            {/* This will show if the user has enough reports available */}

            {organization?.mobilityMovement! > 0 && (
              <Stack space="large">
                <Stack space="medium">
                  <Stack space="small">
                    <Heading>{t('mobility_project.mobility_project_dialog.title')}</Heading>
                    <Text>{t('mobility_project.mobility_project_dialog.cta')}</Text>
                  </Stack>

                  {/*<Stack space="small">
                    <Calendar
                      startDate={startDate}
                      endDate={endDate}
                      monthsShown={2}
                      onChange={onDateChange}
                      excludeDates={excludedDates}
                      maxDate={startDate.addDays(30)}
                      excludeDateIntervals={[
                        { start: new Date(today), end: new Date(today.addDays(60)) },
                      ]}
                    />
                    </Stack>*/}

                  <Stack space="medium">
                    <Button
                      onClick={handleCreateMobilityProject}
                      loading={false}
                      variant="primary"
                      full
                    >
                      {t('mobility_project.mobility_project_dialog.action_button')}
                    </Button>
                  </Stack>
                </Stack>
              </Stack>
            )}

            {/* This will show if the user is out of projects */}

            {organization?.mobilityMovement! === 0 && (
              <Stack space="medium">
                <Stack space="medium">
                  <Stack space="small">
                    <Heading>{t('mobility_project.mobility_project_dialog.title')}</Heading>
                    <Text>{t('mobility_project.no_projects_available.cta')}</Text>
                  </Stack>
                  <Stack space="medium">
                    <Button onClick={handleMobilityDialog} loading={false} variant="primary" full>
                      {t('mobility_project.no_projects_available.action_button')}
                    </Button>
                  </Stack>
                </Stack>
              </Stack>
            )}
          </React.Fragment>
        )}

        {/* Mobility project dialog content */}

        {mobilityType === 'historic' && (
          <React.Fragment>
            {/* This will show if the user has enough reports available */}

            {organization?.mobilityHistorical! > 0 && (
              <Stack space="medium">
                <Stack space="medium">
                  <Stack space="small">
                    <Heading>{t('mobility_project.historic_project_dialog.title')}</Heading>
                    <Text>{t('mobility_project.historic_project_dialog.cta')}</Text>
                  </Stack>
                  <Stack space="medium">
                    <Button
                      onClick={handleCreateMobilityProject}
                      loading={false}
                      variant="primary"
                      full
                    >
                      {t('mobility_project.historic_project_dialog.action_button')}
                    </Button>
                  </Stack>
                </Stack>
              </Stack>
            )}

            {/* This will show if the user is out of projects */}

            {organization?.mobilityHistorical! === 0 && (
              <Stack space="medium">
                <Stack space="medium">
                  <Stack space="small">
                    <Heading>{t('mobility_project.historic_project_dialog.title')}</Heading>
                    <Text>{t('mobility_project.no_projects_available.cta')}</Text>
                  </Stack>
                  <Stack space="medium">
                    <Button onClick={handleMobilityDialog} loading={false} variant="primary" full>
                      {t('mobility_project.no_projects_available.action_button')}
                    </Button>
                  </Stack>
                </Stack>
              </Stack>
            )}
          </React.Fragment>
        )}
      </Dialog>

      {/* Mobility menu */}

      {menuActive && orgMM > 0 && orgMH > 0 && (
        <nav>
          <div style={buttonContainerStyles}>
            <button onClick={handleMobilityClick} style={buttonStyles}>
              <Tooltip
                label={t('mobility_project.mobility_project_menu.buttons.mobility')}
                direction="LEFT_CENTER"
              >
                <Icon className={styles.buttonIcon} name="focus-3-line" size="lg" />
              </Tooltip>
            </button>
          </div>
        </nav>
      )}

      {menuActive && orgMM > 0 && orgMH < 1 && (
        <nav className={styles.mobilityNav}>
          <div style={buttonContainerStyles}>
            <button onClick={handleMobilityClick} style={buttonStyles}>
              <Tooltip
                label={t('mobility_project.mobility_project_menu.buttons.mobility')}
                direction="LEFT_CENTER"
              >
                <Icon className={styles.buttonIcon} name="focus-3-line" size="lg" />
              </Tooltip>
            </button>
          </div>
        </nav>
      )}

      {menuActive && orgMH > 0 && orgMM < 1 && (
        <nav className={styles.mobilityNav}>
          <div style={buttonContainerStyles}>
            <button onClick={handleMobilityClick} style={buttonStyles}>
              <Tooltip
                label={t('mobility_project.mobility_project_menu.buttons.mobility')}
                direction="LEFT_CENTER"
              >
                <Icon className={styles.buttonIcon} name="focus-3-line" size="lg" />
              </Tooltip>
            </button>
          </div>
        </nav>
      )}

      {menuActive && orgMH > 0 && orgMM > 0 && (
        <nav className={styles.mobilityNav}>
          <div style={buttonContainerStyles}>
            <button onClick={handleHistoricClick} style={buttonStyles}>
              <Tooltip
                label={t('mobility_project.mobility_project_menu.buttons.historic')}
                direction="LEFT_CENTER"
              >
                <Icon className={styles.buttonIcon} name="shopping-basket-line" size="lg" />
              </Tooltip>
            </button>
          </div>
        </nav>
      )}
      {(orgMM > 0 || orgMH > 0) && (
        <div style={buttonContainerStyles}>
          <button onClick={() => setMenuActive(!menuActive)} style={buttonStyles}>
            <Tooltip
              label={t('mobility_project.mobility_project_menu.buttons.open')}
              direction="LEFT_CENTER"
            >
              <Icon className={styles.buttonIcon} name="gps-line" size="lg" />
            </Tooltip>
          </button>
        </div>
      )}
    </div>
  )
}

MobilityMenu.displayName = 'MobilityMenu'
